import Login from './pages/Login.vue'
import NotFound from './pages/404.vue'
import Home from './pages/Home.vue'
import Main from './pages/Main.vue'
//管理员管理
import Adminlist from './pages/admin/index.vue'
import Addminupdte from './pages/admin/updte.vue'
import Addminadd from './pages/admin/add.vue'
import Adminlog from './pages/admin/Adminlog.vue'
//角色管理
import Rolelist from './pages/role/index.vue'
import Roleupdte from './pages/role/updte.vue'
import Roleadd from './pages/role/add.vue'
//集团管理
import Companylist from './pages/company/index.vue'
import Companyupdte from './pages/company/updte.vue'
import Companyadd from './pages/company/add.vue'
import Companyadmin from './pages/company/adminlist.vue'
import companyadminadd from './pages/company/companyadminadd.vue'
import companyadminupdte from './pages/company/companyadminupdte.vue'
import servicelist from './pages/company/servicelist.vue'
import serviceset from './pages/company/serviceset.vue'

//权限管理
import platformlist from './pages/privileges/index.vue'
import platformadd from './pages/privileges/platformadd.vue'
import platformupdte from './pages/privileges/platformupdte.vue'
import aprtmentindex from './pages/privileges/aprtmentindex.vue'
import aprtmentadd from './pages/privileges/aprtmentadd.vue'
import aprtmentupdte from './pages/privileges/aprtmentupdte.vue'
import companyindex from './pages/privileges/companyindex.vue'
import companyaddpl from './pages/privileges/companyadd.vue'
import companyupdtepl from './pages/privileges/companyupdte.vue'
import hotelindex from './pages/privileges/hotelindex.vue'
import hoteladd from './pages/privileges/hoteladd.vue'
import hotelupdte from './pages/privileges/hotelupdte.vue'
//菜单管理
import menulist from './pages/menu/index.vue'
import hotel_menu from './pages/menu/hotel_menu.vue'
import meeting from './pages/menu/meeting.vue'
import company_menu from './pages/menu/company_menu.vue'

//系统设置
import paymethodindex from './pages/System/paymethodindex.vue'
import paymethodcompany from './pages/System/paymethodcompany.vue'
import setting from './pages/System/setting.vue'
import paymethodupdate from './pages/System/paymethodupdate.vue'
import companyaddpay from './pages/System/companyadd.vue'
import companyupdtepay from './pages/System/companyupdte.vue'
//服务
import serviceindex from './pages/service/index.vue'
import serviceupdte from './pages/service/updte.vue'
import serviceadd from './pages/service/add.vue'
//数据字典
import dictionary from './pages/dictionaries/dictionary.vue'
import noticeadd from './pages/notice/add.vue'
import noticeupdte from './pages/notice/updte.vue'
import noticeindex from './pages/notice/index.vue'



let routes = [{
    path: '/login',
    component: Login,
    name: '',
    hidden: true
  },
  {
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/',
    component: Home,
    name: '管理员管理',
    iconCls: 'ios-home', //图标样式class
    children: [{
        path: '/Adminlist',
        component: Adminlist,
        name: '管理员列表'
      },
      {
        path: '/Rolelist',
        component: Rolelist,
        name: '角色管理'
      },
      {
        path: '/adminupdte',
        component: Addminupdte,
        name: '编辑管理员',
        hidden: true
      },
      {
        path: '/Adminlog',
        component: Adminlog,
        name: '操作日志',
        hidden: true
      },

      {
        path: '/adminadd',
        component: Addminadd,
        name: '新增管理员',
        hidden: true
      },
      {
        path: '/roleupdte',
        component: Roleupdte,
        name: '编辑角色',
        hidden: true
      },
      {
        path: '/roleadd',
        component: Roleadd,
        name: '新增角色',
        hidden: true
      }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '集团管理',
    iconCls: 'ios-home', //图标样式class
    children: [{
        path: '/Companylist',
        component: Companylist,
        name: '集团列表'
      },
      {
        path: '/companyupdte',
        component: Companyupdte,
        name: '编辑集团',
        hidden: true
      },
      {
        path: '/companyadd',
        component: Companyadd,
        name: '添加集团',
        hidden: true
      },
      {
        path: '/companyadmin',
        component: Companyadmin,
        name: '集团管理员列表',
        hidden: true
      },
      {
        path: '/companyadminadd',
        component: companyadminadd,
        name: '添加管理员',
        hidden: true
      },
      {
        path: '/companyadminupdte',
        component: companyadminupdte,
        name: '修改管理员',
        hidden: true
      },
      {
        path: '/servicelist',
        component: servicelist,
        name: '集团服务权限表',
        hidden: true
      },
      {
        path: '/serviceset',
        component: serviceset,
        name: '设置集团服务权限表',
        hidden: true
      },
      
      
    ]
  },
  {
    path: '/',
    component: Home,
    name: '权限管理',
    iconCls: 'ios-home', //图标样式class
    children: [{
        path: '/platformlist',
        component: platformlist,
        name: '权限列表',
        hidden: true
      },
      {
        path: '/platformadd',
        component: platformadd,
        name: '添加平台方权限',
        hidden: true
      },
      {
        path: '/platformupdte',
        component: platformupdte,
        name: '修改平台方权限',
        hidden: true
      },
      {
        path: '/aprtmentindex',
        component: aprtmentindex,
        name: '公寓权限列表',
        hidden: true
      },
      {
        path: '/aprtmentadd',
        component: aprtmentadd,
        name: '添加公寓权限',
        hidden: true
      },
      {
        path: '/aprtmentupdte',
        component: aprtmentupdte,
        name: '修改公寓权限',
        hidden: true
      },
      {
        path: '/companyindex',
        component: companyindex,
        name: '集团权限列表',
        hidden: true
      },
      {
        path: '/companyaddpl',
        component: companyaddpl,
        name: '添加集团权限',
        hidden: true
      },
      {
        path: '/companyupdtepl',
        component: companyupdtepl,
        name: '修改集团权限',
        hidden: true
      },
      {
        path: '/hotelindex',
        component: hotelindex,
        name: '酒店权限列表',
        hidden: true
      },
      {
        path: '/hoteladd',
        component: hoteladd,
        name: '添加酒店权限',
        hidden: true
      },
      {
        path: '/hotelupdte',
        component: hotelupdte,
        name: '修改酒店权限',
        hidden: true
      }

    ]
  },
  {
    path: '/',
    component: Home,
    name: '菜单管理',
    iconCls: 'ios-home', //图标样式class
    children: [{
        path: '/menulist',
        component: menulist,
        name: '平台菜单列表'
      },
      {
        path: '/company_menu',
        component: company_menu,
        name: '集团菜单列表'
      },
      {
        path: '/hotel_menu',
        component: hotel_menu,
        name: '公寓菜单列表'
      },
      {
        path: '/meeting',
        component: meeting,
        name: '会议菜单列表'
      },
      

    ]

  },
  {
    path: '/',
    component: Home,
    name: '系统管理',
    iconCls: 'ios-home', //图标样式class
    children: [{
        path: '/paymethodindex',
        component: paymethodindex,
        name: '支付方式列表'
      },
      {
        path: '/paymethodcompany',
        component: paymethodcompany,
        name: '支付权限列表'
      },
      {
        path: '/setting',
        component: setting,
        name: '系统配置'
      },
      {
        path: '/paymethodupdate',
        component: paymethodupdate,
        name: '支付权限修改'
      },
      {
        path: '/companyaddpay',
        component: companyaddpay,
        name: '为集团添加支付权限'
      },
      {
        path: '/companyupdtepay',
        component: companyupdtepay,
        name: '为集团修改支付权限'
      },

    ]

  },
  {
    path: '/',
    component: Home,
    name: '服务管理',
    iconCls: 'ios-home', //图标样式class
    children: [{
        path: '/serviceindex',
        component: serviceindex,
        name: '服务列表'
      },
      {
        path: '/serviceadd',
        component: serviceadd,
        name: '新增服务'
      },
      {
        path: '/serviceupdte',
        component: serviceupdte,
        name: '修改服务'
      },
      


    ]

  },
  {
    path: '/',
    component: Home,
    name: '数据自动字典',
    iconCls: 'ios-home', //图标样式class
    children: [{
        path: '/dictionary',
        component: dictionary,
        name: '省市区'
      },


    ]

  },
  {
    path: '/',
    component: Home,
    name: '数据自动字典',
    iconCls: 'ios-home', //图标样式class
    children: [{
        path: '/noticeindex',
        component: noticeindex,
        name: '公告列表'
      },
      {
        path: '/noticeadd',
        component: noticeadd,
        name: '新增公告'
      },
      {
        path: '/noticeupdte',
        component: noticeupdte,
        name: '修改公告'
      }
      


    ]

  },
  {
    path: '*',
    hidden: true,
    redirect: {
      path: '/404'
    }
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js